// caution /!\ name must be the same than the name in the route
export const themes: any[] = [
  {
    lang: {
      country: "ba",
      code: "bs",
      default: true,
    },
    ProductThemes: [
      {
        name: "svi-proizvodi",
        id: "_none",
      },
      {
        name: "novi-proizvodi",
        id: "PFOIEUH983H",
      },
      {
        name: "konzervirani-proizvodi",
        id: "CAN",
      },
      {
        name: "zamrznuti-proizvodi",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "svi-recepti",
        id: "_none",
      },
      {
        name: "predjela-i-grickalice",
        id: "13",
      },
      {
        name: "supe-i-borst",
        id: "4",
      },
      {
        name: "glavno-jelo",
        id: "14",
      },
      {
        name: "salate",
        id: "17",
      },
      {
        name: "deserti",
        id: "7",
      },
    ],
  },
  {
    lang: {
      country: "com",
      code: "en",
      default: true,
    },
    ProductThemes: [
      {
        name: "news",
        id: "OIFZOP8",
      },
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "starter",
        id: "ENT",
      },
      {
        name: "main-course",
        id: "PLP",
      },
      {
        name: "ingredients-recipes",
        id: "ING",
      },
      {
        name: "accompaniment",
        id: "ACC",
      },
      {
        name: "salads",
        id: "SAL",
      },
      {
        name: "snacking",
        id: "SNK",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "party-plate",
        id: "1",
      },
      {
        name: "aperitif",
        id: "2",
      },
      {
        name: "accompaniment",
        id: "9",
      },
    ],
  },
  {
    lang: {
      country: "fr",
      code: "fr",
      default: true,
    },
    ProductThemes: [
      {
        name: "nouveautes",
        id: "PFOIEUH983H",
      },
      {
        name: "tous",
        id: "_none",
      },
      {
        name: "entrees",
        id: "ENT",
      },
      {
        name: "plat-principal",
        id: "PLP",
      },
      {
        name: "ingredients-recettes",
        id: "ING",
      },
      {
        name: "accompagnements",
        id: "ACC",
      },
      {
        name: "tout-pour-mes-salades",
        id: "SAL",
      },
      {
        name: "snacking",
        id: "SNK",
      },
      {
        name: "pasta-pronto",
        id: "PPO",
      },
    ],
    RecipeThemes: [
      {
        name: "tous",
        id: "_none",
      },
      {
        name: "base-de-chou-fleur",
        id: "34",
      },
      {
        name: "base-de-pommes-de-terre",
        id: "35",
      },
      {
        name: "base-de-carottes",
        id: "36",
      },
      {
        name: "base-d-epinards",
        id: "37",
      },
      {
        name: "base-de-poivrons",
        id: "38",
      },
      {
        name: "base-de-champignons",
        id: "39",
      },
      {
        name: "base-de-haricots-verts-plats",
        id: "40",
      },
      {
        name: "base-de-mais",
        id: "41",
      },
      {
        name: "petits-pois-soja",
        id: "42",
      },
      {
        name: "base-de-courgettes",
        id: "47",
      },
      {
        name: "base-de-brocolis",
        id: "46",
      },
      {
        name: "base-de-tomates",
        id: "48",
      },
      {
        name: "base-de-roquette",
        id: "49",
      },
      {
        name: "base-de-mache",
        id: "50",
      },
      {
        name: "base-de-pois-chiche",
        id: "45",
      },
      {
        name: "base-de-lentilles",
        id: "51",
      },
    ],
  },
  {
    lang: {
      country: "bg",
      code: "bg",
      default: true,
    },
    ProductThemes: [
      {
        name: "vsichki-produkti",
        id: "_none",
      },
      {
        name: "novini-za-produkti",
        id: "PFOIEUH983H",
      },
      {
        name: "konservirani-produkti",
        id: "CAN",
      },
      {
        name: "zamrazeni-produkti",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "vsiciki-reterti",
        id: "_none",
      },
      {
        name: "preziatiia-i-zakuski",
        id: "13",
      },
      {
        name: "supi",
        id: "4",
      },
      {
        name: "osnovni-vidove",
        id: "14",
      },
      {
        name: "salati",
        id: "17",
      },
      {
        name: "deserti",
        id: "7",
      },
      { name: "tsarevitsa", id: "41" },
      { name: "piper", id: "56" },
      { name: "morkovi", id: "36" },
      { name: "zelen-bob", id: "40" },
      { name: "domati", id: "48" },
      { name: "cherven-bob", id: "43" },
      { name: "suh-bob", id: "70" },
      { name: "gabi", id: "39" },
      { name: "kartofi-i-kartofi", id: "35" },
      { name: "patladzhan", id: "54" },
      { name: "brokoli", id: "46" },
      { name: "spanak", id: "37" },
      { name: "krastavitsa", id: "58" },
      { name: "karfiol", id: "34" },
    ],
  },
  {
    lang: {
      country: "be",
      code: "fr",
      default: true,
    },
    ProductThemes: [
      {
        name: "nouveautes",
        id: "PFOIEUH983H",
      },
      {
        name: "tous",
        id: "_none",
      },
      {
        name: "fr/tous",
        id: "_none",
      },
      {
        name: "mais",
        id: "MAI",
      },
      {
        name: "legumineuses",
        id: "LEG",
      },
      {
        name: "legumes",
        id: "LGR",
      },
      {
        name: "cereales",
        id: "CER",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
      {
        name: "spreads",
        id: "SPR",
      },
      {
        name: "pasta-pronto",
        id: "PAP",
      },
    ],
    RecipeThemes: [
      {
        name: "tous",
        id: "_none",
      },
      {
        name: "fr/tous",
        id: "_none",
      },
      {
        name: "mexicain",
        id: "25",
      },
      {
        name: "le-tour-du-monde",
        id: "26",
      },
      {
        name: "une-journee-sans-viande",
        id: "27",
      },
      {
        name: "soupes",
        id: "4",
      },
      {
        name: "bols",
        id: "18",
      },
      {
        name: "base-de-mais",
        id: "41",
      },
      {
        name: "base-de-pois-chiche",
        id: "45",
      },
      {
        name: "base-de-haricot-rouge",
        id: "43",
      },
      {
        name: "base-de-legumineuses",
        id: "52",
      },
      {
        name: "base-de-lentilles",
        id: "51",
      },
    ],
  },
  {
    lang: {
      country: "be",
      code: "nl",
      default: true,
    },
    ProductThemes: [
      {
        name: "neue-produkte",
        id: "PFOIEUH983H",
      },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "nl/alle",
        id: "_none",
      },
      {
        name: "peulvruchten",
        id: "LEG",
      },
      {
        name: "mais",
        id: "MAI",
      },
      {
        name: "groenten",
        id: "DLE",
      },
      {
        name: "maaltijdverrijkers",
        id: "EDR",
      },
      {
        name: "bonengerechten",
        id: "PDH",
      },
      {
        name: "groentepasta-rijst",
        id: "PHR",
      },
      {
        name: "groenterijst",
        id: "RAL",
      },
      {
        name: "gegrilde-groenten",
        id: "LGR",
      },
      {
        name: "ovengroenten",
        id: "LDF",
      },
      {
        name: "granen",
        id: "CER",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
      {
        name: "spreads",
        id: "SPR",
      },
      {
        name: "pasta-pronto",
        id: "PAP",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "nl/alle",
        id: "_none",
      },
      {
        name: "salades",
        id: "17",
      },
      {
        name: "mexicaans",
        id: "25",
      },
      {
        name: "de-wereld-rond",
        id: "26",
      },
      {
        name: "dagje-zonder-vlees",
        id: "27",
      },
      {
        name: "soepen",
        id: "19",
      },
      {
        name: "bowls",
        id: "18",
      },
      {
        name: "basis-van-mais",
        id: "41",
      },
      {
        name: "basis-van-kikkererwten",
        id: "45",
      },
      {
        name: "basis-van-rode-kidneybonen",
        id: "43",
      },
      {
        name: "basis-van-linzen",
        id: "51",
      },
      {
        name: "basis-van-peulvruchten",
        id: "52",
      },
      {
        name: "basis-van-edamame",
        id: "53",
      },
    ],
  },
  {
    lang: {
      country: "de",
      code: "de",
      default: true,
    },
    ProductThemes: [
      // {
      //   name: 'neue-produkte',
      //   id: 'NEW'
      // },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "gemuesekonserven",
        id: "CAN",
      },
      {
        name: "frische-salate",
        id: "FSH",
      },
      {
        name: "frische-gemusemischungen",
        id: "MLF",
      },
      {
        name: "suppen",
        id: "SUP",
      },
      {
        name: "pur-huelsenfruechte",
        id: "PDL",
      },
      {
        name: "salatschalen",
        id: "SDB",
      },
      {
        name: "bio-produkte",
        id: "BIO",
      },
      {
        name: "frisch-vom-feld",
        id: "RAL",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
      {
        name: "dampfgegart",
        id: "LGV",
      },
      {
        name: "world-kitchen",
        id: "WKN",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "salate-und-grillen",
        id: "12",
      },
      {
        name: "snacks-und-fingerfood",
        id: "13",
      },
      {
        name: "hauptgang",
        id: "14",
      },
      {
        name: "nachtisch-und-backwaren",
        id: "15",
      },
      {
        name: "vorspeisen-und-suppen",
        id: "16",
      },
      {
        name: "mit-tomaten",
        id: "48",
      },
      {
        name: "mit-moehren",
        id: "36",
      },
      {
        name: "mit-mais",
        id: "41",
      },
      {
        name: "mit-kidney-bohnen",
        id: "40",
      },
      {
        name: "mit-paprika",
        id: "56",
      },
      {
        name: "mit-kichererbsen",
        id: "45",
      },
      {
        name: "mit-rucola",
        id: "49",
      },
      {
        name: "mit-pilze",
        id: "39",
      },
      {
        name: "mit-erbsen",
        id: "42",
      },
      {
        name: "mit-zucchini",
        id: "47",
      },
      {
        name: "mit-linsen",
        id: "51",
      },
      {
        name: "mit-spinat",
        id: "37",
      },
      {
        name: "mit-gemueseart",
        id: "59",
      },
      {
        name: "gruene-bohnen",
        id: "40",
      },
      {
        name: "vorspeisen-und-suppen",
        id: "16",
      },
    ],
  },
  {
    lang: {
      country: "dk",
      code: "da",
      default: true,
    },
    ProductThemes: [
      {
        name: "nyheder",
        id: "PFOIEUH983H",
      },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "baelgfrugter",
        id: "BEA",
      },
      {
        name: "bonner-sauce",
        id: "BIS",
      },
      {
        name: "champignoner",
        id: "MUS",
      },
      {
        name: "tex-mex",
        id: "TEX",
      },
      {
        name: "majs",
        id: "MAI",
      },
      {
        name: "gronne-grontsager",
        id: "DLE",
      },
      {
        name: "mini-packs",
        id: "EDR",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "forretter-supper",
        id: "16",
      },
      {
        name: "hovedretter",
        id: "14",
      },
      {
        name: "smaretter-snacks",
        id: "13",
      },
      {
        name: "tilbehor",
        id: "9",
      },
      {
        name: "salater",
        id: "17",
      },
      {
        name: "sodt-bagvaerk",
        id: "15",
      },
      { name: "majs", id: "41" },
      { name: "kikaerter", id: "45" },
      { name: "rode-kidneybonner", id: "43" },
      { name: "linser", id: "51" },
      { name: "tomater", id: "48" },
      { name: "avocado", id: "63" },
      { name: "champignoner", id: "39" },
      { name: "kartofler", id: "35" },
      { name: "gulerodder", id: "36" },
      { name: "squash", id: "65" },
      { name: "agurker", id: "58" },
      { name: "peberfrugter", id: "38" },
      { name: "spinater", id: "37" },
      { name: "sode-kartofler", id: "35" },
      { name: "gronkal", id: "65" },
    ],
  },
  {
    lang: {
      country: "at",
      code: "de",
      default: true,
    },
    ProductThemes: [
      // {
      //   name: 'neue-produkte',
      //   id: 'NEW'
      // },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "bio",
        id: "BIO",
      },
      {
        name: "mais",
        id: "MAI",
      },
      {
        name: "pilze",
        id: "MUS",
      },
      {
        name: "hulsenfruchte",
        id: "LEG",
      },
      {
        name: "grungemuse",
        id: "DLE",
      },
      {
        name: "reis",
        id: "PHR",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "salate-und-grillen",
        id: "12",
      },
      {
        name: "snacks-und-fingerfood",
        id: "13",
      },
      {
        name: "hauptgang",
        id: "14",
      },
      {
        name: "nachtisch-und-backwaren",
        id: "15",
      },
      {
        name: "vorspeisen-und-suppen",
        id: "16",
      },
      { name: "tomaten", id: "48" },
      { name: "mais", id: "41" },
      { name: "erbsen", id: "42" },
      { name: "paprika", id: "56" },
      { name: "moehren", id: "36" },
      { name: "pilze", id: "39" },
      { name: "kidney-bohnen", id: "43" },
      { name: "kichererbsen", id: "45" },
      { name: "zucchini", id: "47" },
      { name: "kartoffeln", id: "35" },
      { name: "gruene-bohnen", id: "40" },
      { name: "spinat", id: "37" },
      { name: "linsen", id: "51" },
      { name: "weiße-bohnen", id: "44" },
    ],
  },
  {
    lang: {
      country: "nl",
      code: "nl",
      default: true,
    },
    ProductThemes: [
      {
        name: "neue-produkte",
        id: "PFOIEUH983H",
      },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "nl/alle",
        id: "_none",
      },
      {
        name: "peulvruchten",
        id: "LEG",
      },
      {
        name: "mais",
        id: "MAI",
      },
      {
        name: "groenten",
        id: "DLE",
      },
      {
        name: "maaltijdverrijkers",
        id: "EDR",
      },
      {
        name: "bonengerechten",
        id: "PDH",
      },
      {
        name: "groentepasta-rijst",
        id: "PHR",
      },
      {
        name: "groenterijst",
        id: "RAL",
      },
      {
        name: "gegrilde-groenten",
        id: "LGR",
      },
      {
        name: "ovengroenten",
        id: "LDF",
      },
      {
        name: "groenten-voor-soep",
        id: "LGS",
      },
      {
        name: "groente-rondo-s",
        id: "PDL",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
      {
        name: "pasta-pronto",
        id: "PAP",
      },
      {
        name: "spreads",
        id: "SPR",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "nl/alle",
        id: "_none",
      },
      {
        name: "salades",
        id: "17",
      },
      {
        name: "mexicaans",
        id: "25",
      },
      {
        name: "de-wereld-rond",
        id: "26",
      },
      {
        name: "dagje-zonder-vlees",
        id: "27",
      },
      {
        name: "laag-in-koolhydraten",
        id: "28",
      },
      {
        name: "bowls",
        id: "18",
      },
      {
        name: "soepen",
        id: "19",
      },
      {
        name: "overige-gerechten",
        id: "23",
      },
      {
        name: "basis-van-mais",
        id: "41",
      },
      {
        name: "basis-van-kikkererwten",
        id: "45",
      },
      {
        name: "basis-van-rode-kidneybonen",
        id: "43",
      },
      {
        name: "basis-van-linzen",
        id: "51",
      },
      {
        name: "basis-van-courgettes",
        id: "47",
      },
      {
        name: "basis-van-edamame",
        id: "53",
      },
      {
        name: "basis-van-peulvruchten",
        id: "52",
      },
      {
        name: "basis-van-bloemkool",
        id: "34",
      },
      {
        name: "basis-van-paprika",
        id: "38",
      },
      {
        name: "basis-van-broccoli",
        id: "46",
      },
      {
        name: "basis-van-aubergine",
        id: "54",
      },
      {
        name: "basis-van-doperwtjes",
        id: "71",
      },
      {
        name: "basis-van-tomaten",
        id: "48",
      },
      {
        name: "basis-van-pompoen",
        id: "55",
      },
      {
        name: "basis-van-erwten",
        id: "42",
      },
      {
        name: "basis-van-sperziebonen",
        id: "40",
      },
    ],
  },
  {
    lang: {
      country: "hr",
      code: "hr",
      default: true,
    },
    ProductThemes: [
      {
        name: "svi-proizvodi",
        id: "_none",
      },
      {
        name: "proizvod-vijesti",
        id: "PFOIEUH983H",
      },
      {
        name: "konzervirani-proizvodi",
        id: "CAN",
      },
      {
        name: "zamrznuti-proizvodi",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "svi-recepti",
        id: "_none",
      },
      {
        name: "predjela-i-grickalice",
        id: "13",
      },
      {
        name: "juhe-i-borsc",
        id: "4",
      },
      {
        name: "glavni-tecaj",
        id: "14",
      },
      {
        name: "salate",
        id: "17",
      },
      {
        name: "deserti",
        id: "7",
      },
    ],
  },
  {
    lang: {
      country: "hu",
      code: "hu",
      default: true,
    },
    ProductThemes: [
      {
        name: "osszes-kerdes",
        id: "_none",
      },
      {
        name: "meno-klasszikusok",
        id: "CLS",
      },
      {
        name: "salatakhoz",
        id: "FSD",
      },
      {
        name: "novenyi-protein",
        id: "VGP",
      },
      {
        name: "keszetelek",
        id: "RDM",
      },
      {
        name: "koretek",
        id: "ACC",
      },
    ],
    RecipeThemes: [
      {
        name: "osszes-kerdes",
        id: "_none",
      },
      {
        name: "kukoricaval",
        id: "41",
      },
      {
        name: "borsoval",
        id: "42",
      },
      {
        name: "vorosbabbal",
        id: "43",
      },
      {
        name: "babbal",
        id: "44",
      },
      {
        name: "lencsevel",
        id: "33",
      },
      {
        name: "csicseriborsoval",
        id: "45",
      },
      {
        name: "zoldbabbal",
        id: "40",
      },
      {
        name: "brokkolival",
        id: "46",
      },
      {
        name: "karfiollal",
        id: "34",
      },
      { name: "gomba", id: "39" },
      { name: "spenot", id: "37" },
    ],
  },
  {
    lang: {
      country: "cz",
      code: "cs",
      default: true,
    },
    ProductThemes: [
      {
        name: "nouveautes",
        id: "PFOIEUH983H",
      },
      {
        name: "vse",
        id: "_none",
      },
      {
        name: "sterilovana-zelenina",
        id: "CAN",
      },
      {
        name: "mrazena-zelenina",
        id: "FRZ",
      },
      {
        name: "hotova-jidla",
        id: "RDM",
      },
      {
        name: "creatif",
        id: "CRT",
      },
      {
        name: "bon-menu",
        id: "VCR",
      },
      {
        name: "vapeur",
        id: "LGV",
      },
    ],
    RecipeThemes: [
      {
        name: "vsechna-temata",
        id: "_none",
      },
      {
        name: "salaty-predkrmy",
        id: "3",
      },
      {
        name: "polevky",
        id: "4",
      },
      {
        name: "hlavni-jidla",
        id: "14",
      },
      {
        name: "dezerty",
        id: "7",
      },
      { name: "cizrna", id: "45" },
      { name: "dyne", id: "55" },
      { name: "fazole-cervene", id: "43" },
      { name: "fazole-fava", id: "40" },
      { name: "kvetak", id: "34" },
      { name: "mrkev", id: "36" },
      { name: "cocka", id: "51" },
      { name: "spenat", id: "37" },
    ],
  },
  {
    lang: {
      country: "sk",
      code: "sk",
      default: true,
    },
    ProductThemes: [
      {
        name: "nouveautes",
        id: "PFOIEUH983H",
      },
      {
        name: "vsetky-temy",
        id: "_none",
      },
      {
        name: "sterilizovana-zelenina",
        id: "CAN",
      },
      {
        name: "mrazena-zelenina",
        id: "FRZ",
      },
      {
        name: "hotove-jedla",
        id: "RDM",
      },
      {
        name: "creatif",
        id: "CRT",
      },
      {
        name: "bon-menu",
        id: "VCR",
      },
      {
        name: "vapeur",
        id: "LGV",
      },
    ],
    RecipeThemes: [
      {
        name: "vsetky-temy",
        id: "_none",
      },
      {
        name: "salaty-predkrmy",
        id: "3",
      },
      {
        name: "polievky",
        id: "4",
      },
      {
        name: "hlavne-jedla",
        id: "14",
      },
      {
        name: "dezerty",
        id: "7",
      },
      { name: "cicer", id: "45" },
      { name: "tekvica", id: "55" },
      { name: "karfiol", id: "34" },
      { name: "spenat", id: "37" },
      { name: "fazula-cervene", id: "43" },
      { name: "fazula-fava", id: "40" },
      { name: "mrkva", id: "36" },
      { name: "zeleninovu-zmes", id: "59" },
      { name: "zemiaky", id: "35" },
      { name: "sosovka", id: "51" },
    ],
  },
  {
    lang: {
      country: "pl",
      code: "pl",
      default: true,
    },
    ProductThemes: [
      {
        name: "nouveautes",
        id: "PFOIEUH983H",
      },
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "nowosci",
        id: "NEW",
      },
      {
        name: "warzywa-w-puszkach",
        id: "CAN",
      },
      {
        name: "pieczarki",
        id: "MUS",
      },
      {
        name: "dania-na-cieplo",
        id: "RDM",
      },
      {
        name: "mrozonki",
        id: "FRZ",
      },
      {
        name: "kaszetka-do-gotowania",
        id: "ACC",
      },
      {
        name: "good-lunch",
        id: "LBW",
      },
      {
        name: "warzywa-w-formie-makaronu",
        id: "LGO",
      },
      {
        name: "straczki",
        id: "LEG",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "recette-festive",
        id: "1",
      },
      {
        name: "aperitif",
        id: "2",
      },
      {
        name: "accompagnements",
        id: "9",
      },
    ],
  },
  {
    lang: {
      country: "es",
      code: "es",
      default: true,
    },
    ProductThemes: [
      {
        name: "novedades",
        id: "PFOIEUH983H",
      },
      {
        name: "todos-remas",
        id: "_none",
      },
      {
        name: "bio",
        id: "BIO",
      },
      {
        name: "para-tus-ensaladas",
        id: "SAL",
      },
      {
        name: "calentar-y-listo",
        id: "RDM",
      },
      {
        name: "listo-para-comer",
        id: "LBW",
      },
      {
        name: "para-tus-recetas",
        id: "PHR",
      },
    ],
    RecipeThemes: [
      {
        name: "todos-remas",
        id: "_none",
      },
      {
        name: "aperitivo-tapa",
        id: "2",
      },
      {
        name: "entrante",
        id: "16",
      },
      {
        name: "sopa-crema",
        id: "4",
      },
      {
        name: "ensalada",
        id: "17",
      },
      {
        name: "plato-principal",
        id: "14",
      },
      {
        name: "postre",
        id: "7",
      },
      {
        name: "base-de-zanahorias",
        id: "36",
      },
      {
        name: "base-de-tomates",
        id: "48",
      },
      {
        name: "base-de-guisantes",
        id: "42",
      },
      {
        name: "base-de-champinones",
        id: "39",
      },
      {
        name: "base-de-calabacines",
        id: "47",
      },
      {
        name: "base-de-maiz",
        id: "41",
      },
      {
        name: "base-de-espinacas",
        id: "37",
      },
      {
        name: "base-de-pimientos-rojos",
        id: "57",
      },
      {
        name: "base-de-patatas",
        id: "35",
      },
      {
        name: "base-de-pimientos",
        id: "38",
      },
      {
        name: "base-de-berenjenas",
        id: "54",
      },
      {
        name: "base-de-brocoli",
        id: "46",
      },
      {
        name: "base-de-judias-verdes",
        id: "40",
      },
      {
        name: "base-de-puerros",
        id: "65",
      },
      {
        name: "base-de-aguacate",
        id: "63",
      },
    ],
  },
  {
    lang: {
      country: "pt",
      code: "pt",
      default: true,
    },
    ProductThemes: [
      {
        name: "novidades",
        id: "PFOIEUH983H",
      },
      {
        name: "todos-os-temas",
        id: "_none",
      },
      {
        name: "bio",
        id: "BIO",
      },
      {
        name: "para-as-suas-saladas",
        id: "SAL",
      },
      {
        name: "pronto-para-cozinhar",
        id: "RDM",
      },
      {
        name: "para-as-suas-receitas",
        id: "PHR",
      },
      {
        name: "pronto-a-comer",
        id: "PAC",
      },
    ],
    RecipeThemes: [
      {
        name: "todos-os-temas",
        id: "_none",
      },
      {
        name: "aperitivo",
        id: "2",
      },
      {
        name: "entrada",
        id: "16",
      },
      {
        name: "sopa",
        id: "4",
      },
      {
        name: "salada",
        id: "17",
      },
      {
        name: "prato-principal",
        id: "14",
      },
      {
        name: "sobremesa",
        id: "7",
      },
      { name: "base-de-tomate", id: "48" },
      { name: "base-de-cenouras", id: "36" },
      { name: "base-de-espinafres", id: "37" },
      { name: "base-de-curgetes", id: "47" },
      { name: "base-de-ervilhas", id: "42" },
      { name: "base-de-milho", id: "41" },
      { name: "base-de-cogumelos", id: "39" },
      { name: "base-de-pimentos", id: "38" },
      { name: "base-de-abacates", id: "63" },
      { name: "base-de-batatas", id: "35" },
      { name: "base-de-beringelas", id: "54" },
      { name: "base-de-grao-de-bico", id: "45" },
      { name: "base-de-feijao-verde", id: "40" },
      { name: "base-de-pimentos-vermelhos", id: "57" },
      { name: "base-de-espelta", id: "62" },
      { name: "base-de-lentilhas", id: "51" },
    ],
  },
  {
    lang: {
      country: "it",
      code: "it",
      default: true,
    },
    ProductThemes: [
      {
        name: "prodotti-in-evidenza",
        id: "PFOIEUH983H",
      },
      {
        name: "tutti-temi",
        id: "_none",
      },
      {
        name: "insalate",
        id: "FSD",
      },
      {
        name: "conserve",
        id: "CAN",
      },
      {
        name: "surgelati",
        id: "FRZ",
      },
      {
        name: "piatti-pronti",
        id: "RDM",
      },
      {
        name: "pronti-per-l-aperitivo",
        id: "SNK",
      },
      {
        name: "bio",
        id: "BIO",
      },
      {
        name: "verdure-da-cuocere",
        id: "COO",
      },
    ],
    RecipeThemes: [
      {
        name: "tutti-temi",
        id: "_none",
      },
      {
        name: "tutte-le-ricette",
        id: "_none",
      },
      {
        name: "antipasti-aperitivi",
        id: "2",
      },
      {
        name: "insalate-piatti-unici",
        id: "3",
      },
      {
        name: "primi-piatti",
        id: "23",
      },
      {
        name: "secondi-piatti",
        id: "14",
      },
      {
        name: "con-mais",
        id: "41",
      },
      {
        name: "con-piselli",
        id: "42",
      },
      {
        name: "con-ceci",
        id: "45",
      },
      {
        name: "con-fagiolini",
        id: "40",
      },
      {
        name: "con-carote",
        id: "36",
      },
      {
        name: "con-spinaci",
        id: "37",
      },
      {
        name: "con-edamame",
        id: "53",
      },
      {
        name: "con-pan-di-zucchero",
        id: "66",
      },
      {
        name: "con-lattughino",
        id: "60",
      },
      {
        name: "con-lattuga-iceberg",
        id: "61",
      },
      {
        name: "con-fagioli-canellini",
        id: "67",
      },
      {
        name: "con-lenticchie",
        id: "51",
      },
      {
        name: "con-patate",
        id: "35",
      },
      {
        name: "con-rucola",
        id: "49",
      },
      {
        name: "con-fagioli-rossi",
        id: "43",
      },
      {
        name: "con-songino",
        id: "50",
      },
      {
        name: "dolci",
        id: "7",
      },
      {
        name: "contorni",
        id: "9",
      },
    ],
  },
  {
    lang: {
      country: "se",
      code: "sv",
      default: true,
    },
    ProductThemes: [
      {
        name: "nyheder",
        id: "PFOIEUH983H",
      },
      {
        name: "alla",
        id: "_none",
      },
      {
        name: "baljvaxter",
        id: "BEA",
      },
      {
        name: "majs",
        id: "MAI",
      },
      {
        name: "tex-mex",
        id: "TEX",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
    ],
    RecipeThemes: [
      {
        name: "alla",
        id: "_none",
      },
      {
        name: "forratter-soppor",
        id: "16",
      },
      {
        name: "huvudratter",
        id: "14",
      },
      {
        name: "smaretter-snacks",
        id: "13",
      },
      {
        name: "tillbehor",
        id: "9",
      },
      {
        name: "sallader",
        id: "17",
      },
      {
        name: "sota-bakadevaror",
        id: "15",
      },
      { name: "majs", id: "41" },
      { name: "kikartor", id: "45" },
      { name: "roda-kidneybonor", id: "43" },
      { name: "linser", id: "51" },
      { name: "tomater", id: "48" },
      { name: "champinjoner", id: "39" },
      { name: "moroetter", id: "36" },
    ],
  },
  {
    lang: {
      country: "no",
      code: "no",
      default: true,
    },
    ProductThemes: [
      {
        name: "nyheter",
        id: "PFOIEUH983H",
      },
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "belgfrukter",
        id: "BEA",
      },
      {
        name: "bonner-sauce",
        id: "BIS",
      },
      {
        name: "tex-mex",
        id: "TEX",
      },
      {
        name: "mais",
        id: "MAI",
      },
      {
        name: "gronne-gronnsaker",
        id: "DLE",
      },
      {
        name: "mini-packs",
        id: "EDR",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "forretter-supper",
        id: "16",
      },
      {
        name: "hovedretter",
        id: "14",
      },
      {
        name: "smaretter-snacks",
        id: "13",
      },
      {
        name: "tilbehor",
        id: "9",
      },
      {
        name: "salater",
        id: "17",
      },
      {
        name: "soteretter-bakst",
        id: "15",
      },
      { name: "mais", id: "41" },
      { name: "kikerter", id: "45" },
      { name: "rode-kidneybonner", id: "43" },
      { name: "tomater", id: "48" },
      { name: "linser", id: "51" },
    ],
  },
  {
    lang: {
      country: "fi",
      code: "fi",
      default: true,
    },
    ProductThemes: [
      {
        name: "nyheder",
        id: "PFOIEUH983H",
      },
      {
        name: "kaikki",
        id: "_none",
      },
      {
        name: "maissi",
        id: "MAI",
      },
      {
        name: "palkokasvit",
        id: "BEA",
      },
      {
        name: "pavut-kastikkeessa",
        id: "BIS",
      },
      {
        name: "tex-mex",
        id: "TEX",
      },
      {
        name: "vihreat-vihannekset",
        id: "DLE",
      },
      {
        name: "mini-packs",
        id: "EDR",
      },
      {
        name: "lunch-bowl",
        id: "LBW",
      },
    ],
    RecipeThemes: [
      {
        name: "alle",
        id: "_none",
      },
      {
        name: "alkupalat-ja-keitot",
        id: "16",
      },
      {
        name: "paaruoat",
        id: "14",
      },
      {
        name: "valipalat-ja-naposteltavat",
        id: "13",
      },
      {
        name: "lisukkeet",
        id: "9",
      },
      {
        name: "salaatit",
        id: "17",
      },
      {
        name: "makeat-leivonnaiset",
        id: "15",
      },
      { name: "maissi", id: "41" },
      { name: "kikherneet", id: "45" },
      { name: "punaiset-kidneypavut", id: "43" },
      { name: "linssit", id: "51" },
      { name: "avokado", id: "63" },
      { name: "porkkana", id: "36" },
    ],
  },
  {
    lang: {
      country: "ee",
      code: "et",
      default: true,
    },
    ProductThemes: [
      {
        name: "koik-tooted",
        id: "PFOIEUH983H",
      },
      {
        name: "uudistooted",
        id: "_none",
      },
      {
        name: "moodne-klassika",
        id: "CLS",
      },
      {
        name: "salatitele",
        id: "FSD",
      },
      {
        name: "pohiroogadele",
        id: "PLP",
      },
      {
        name: "suupistetele",
        id: "SNK",
      },
    ],
    RecipeThemes: [
      {
        name: "koik-teemad",
        id: "_none",
      },
      {
        name: "suupisted",
        id: "20",
      },
      {
        name: "salatid",
        id: "17",
      },
      {
        name: "supid",
        id: "19",
      },
      {
        name: "pohiroad",
        id: "14",
      },
      {
        name: "desserdid",
        id: "7",
      },
      { name: "mais", id: "41" },
      { name: "soya-oad", id: "71" },
      { name: "rohelised-aedoad", id: "40" },
      { name: "brokoli", id: "46" },
      { name: "porgand", id: "36" },
      { name: "punased-oad", id: "43" },
    ],
  },
  {
    lang: {
      country: "lt",
      code: "lt",
      default: true,
    },
    ProductThemes: [
      {
        name: "naujienos",
        id: "PFOIEUH983H",
      },
      {
        name: "visi-produktai",
        id: "_none",
      },
      {
        name: "klasikinis",
        id: "CLS",
      },
      {
        name: "salotu-misinys",
        id: "FSD",
      },
      {
        name: "pagrindiniams-patiekalams",
        id: "PLP",
      },
      {
        name: "uzkandziai",
        id: "SNK",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "uzkandziai",
        id: "20",
      },
      {
        name: "salotos",
        id: "17",
      },
      {
        name: "sriubos",
        id: "19",
      },
      {
        name: "pagrindiniai-patiekalai",
        id: "14",
      },
      {
        name: "desertai",
        id: "7",
      },
      { name: "sojos-pupeles", id: "42" },
      { name: "brokolis", id: "46" },
      { name: "kukuruzai", id: "41" },
      { name: "avinzirniai", id: "45" },
      { name: "raudonosios-pupeles", id: "43" },
      { name: "pomidorai", id: "48" },
      { name: "zaliosiosios-pupeles", id: "40" },
    ],
  },
  {
    lang: {
      country: "lv",
      code: "lv",
      default: true,
    },
    ProductThemes: [
      {
        name: "jaunumi",
        id: "PFOIEUH983H",
      },
      {
        name: "visas-temas",
        id: "_none",
      },
      {
        name: "moderna-klasika",
        id: "CLS",
      },
      {
        name: "salatiem",
        id: "FSD",
      },
      {
        name: "pamatedieniem",
        id: "PLP",
      },
      {
        name: "uzkodam",
        id: "SNK",
      },
    ],
    RecipeThemes: [
      {
        name: "visas-temas",
        id: "_none",
      },
      {
        name: "uzkodas",
        id: "20",
      },
      {
        name: "salati",
        id: "17",
      },
      {
        name: "zupas",
        id: "19",
      },
      {
        name: "pamatedieni",
        id: "14",
      },
      {
        name: "deserti",
        id: "7",
      },
      { name: "kukuruza", id: "41" },
      { name: "soya-pupinas", id: "71" },
      { name: "tomats", id: "48" },
      { name: "turku-zirni", id: "45" },
      { name: "zalas-paksu-pupinas", id: "40" },
      { name: "sarkanas-pupinas", id: "43" },
    ],
  },
  {
    lang: {
      country: "il",
      code: "he",
      default: true,
    },
    ProductThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "entree",
        id: "16",
      },
      {
        name: "plat",
        id: "14",
      },
    ],
  },
  {
    lang: {
      country: "al",
      code: "sq",
      default: true,
    },
    ProductThemes: [
      {
        name: "te-gjitha-produktet",
        id: "_none",
      },
      {
        name: "perimet-e-konservuara",
        id: "CAN",
      },
      {
        name: "perimet-e-ngrira",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "te-gjitha-recetat",
        id: "_none",
      },
      {
        name: "meze-dhe-snacks",
        id: "13",
      },
      {
        name: "supat",
        id: "4",
      },
      {
        name: "pjata-kryesore",
        id: "14",
      },
      {
        name: "sallatat",
        id: "17",
      },
      {
        name: "embelsirat",
        id: "7",
      },
    ],
  },
  {
    lang: {
      country: "rs",
      code: "sr",
      default: true,
    },
    ProductThemes: [
      {
        name: "svi-proizvodi",
        id: "_none",
      },
      {
        name: "konzervirano-povrce",
        id: "CAN",
      },
    ],
    RecipeThemes: [
      {
        name: "all-themes",
        id: "_none",
      },
      {
        name: "svi-recepti",
        id: "_none",
      },
      {
        name: "novi-recepti",
        id: "17",
      },
      {
        name: "predjela-i-uzine",
        id: "13",
      },
      {
        name: "supe-i-corbe",
        id: "4",
      },
      {
        name: "glavna-jela",
        id: "14",
      },
      {
        name: "salate",
        id: "17",
      },
      {
        name: "deserti",
        id: "7",
      },
    ],
  },
  {
    lang: {
      country: "gr",
      code: "el",
      default: true,
    },
    ProductThemes: [
      {
        name: "ola-ta-themata",
        id: "_none",
      },
      {
        name: "konserba",
        id: "CAN",
      },
      {
        name: "katepsucmeno",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "ola-ta-themata",
        id: "_none",
      },
      {
        name: "snak-finckerfount",
        id: "13",
      },
      {
        name: "soupes-kai-ckaspatso",
        id: "4",
      },
      {
        name: "kurios-piata",
        id: "14",
      },
      {
        name: "salates",
        id: "17",
      },
      {
        name: "desserts",
        id: "7",
      },
      {
        name: "sunodeutika",
        id: "9",
      },
      { name: "perissotero", id: "41" },
      { name: "prasina-fasolia", id: "40" },
      { name: "kremmydia", id: "64" },
      { name: "mpizelia", id: "42" },
      { name: "kokkines-piperies", id: "57" },
      { name: "karota", id: "36" },
      { name: "kokkino-fasoli", id: "43" },
      { name: "manitaria", id: "39" },
      { name: "spanaki", id: "37" },
    ],
  },
  {
    lang: {
      country: "ro",
      code: "ro",
      default: true,
    },
    ProductThemes: [
      {
        name: "news",
        id: "OIFZOP8",
      },
      {
        name: "toate-produsele",
        id: "_none",
      },
      {
        name: "legume-in-conserva",
        id: "CAN",
      },
      {
        name: "legume-congelate",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "toate-retetele",
        id: "_none",
      },
      {
        name: "aperitive-si-gustari",
        id: "13",
      },
      {
        name: "supe-si-ciorbe",
        id: "4",
      },
      {
        name: "feluri-principale",
        id: "14",
      },
      {
        name: "salate",
        id: "17",
      },
      {
        name: "deserturi",
        id: "7",
      },
      { name: "porumb", id: "41" },
      { name: "ciuperci", id: "39" },
      { name: "mazare-soia", id: "69" },
      { name: "morcovi", id: "36" },
      { name: "fasole-verde", id: "40" },
      { name: "broccoli", id: "46" },
      { name: "spanac", id: "37" },
      { name: "fasole-rosie", id: "43" },
      { name: "ardei-rosii", id: "57" },
      { name: "cartofi", id: "35" },
      { name: "conopida", id: "34" },
      { name: "castravete", id: "58" },
      { name: "naut", id: "45" },
      { name: "linte", id: "51" },
      // {
      //   name: 'garnituri',
      //   id: '9'
      // }
    ],
  },
  {
    lang: {
      country: "ua",
      code: "uk",
      default: true,
    },
    ProductThemes: [
      {
        name: "all",
        id: "_none",
      },
      {
        name: "konservovani-ovochi",
        id: "CAN",
      },
      {
        name: "zamorozheni-ovochi",
        id: "FRZ",
      },
    ],
    RecipeThemes: [
      {
        name: "all",
        id: "_none",
      },
      {
        name: "zakusky-sneky",
        id: "13",
      },
      {
        name: "supy-borshchi",
        id: "4",
      },
      {
        name: "osnovna-strava",
        id: "14",
      },
      {
        name: "salaty",
        id: "17",
      },
      {
        name: "deserty",
        id: "7",
      },
    ],
  },
  {
    lang: {
      country: "br",
      code: "pt",
      default: true,
    },
    ProductThemes: [
      {
        name: "all",
        id: "_none",
      },
      {
        name: "conservas-importadas",
        id: "IMP",
      },
      {
        name: "conservas-nacionais",
        id: "NAT",
      },
      {
        name: "palmitos",
        id: "PLM",
      },
      {
        name: "azeitonas",
        id: "OLV",
      },
      {
        name: "pastas-vegetais",
        id: "PHR",
      },
      {
        name: "congelados",
        id: "FRZ",
      },
      // {
      //   name: "novidades",
      //   id: "PFOIEUH983H",
      // },
      // {
      //   name: "todos-os-temas",
      //   id: "_none",
      // },
      // {
      //   name: "bio",
      //   id: "BIO",
      // },
      // {
      //   name: "para-as-suas-saladas",
      //   id: "SAL",
      // },
      // {
      //   name: "pronto-para-cozinhar",
      //   id: "RDM",
      // },
      // {
      //   name: "para-as-suas-receitas",
      //   id: "PHR",
      // },
    ],
    RecipeThemes: [
      // {
      //   name: "todos-os-temas",
      //   id: "_none",
      // },
      {
        name: "vegetarianas",
        id: "80",
      },
      {
        name: "cremes-e-sopas",
        id: "81",
      },
      {
        name: "tortas-e-quiches",
        id: "82",
      },
      {
        name: "baixas-em-sodio",
        id: "83",
      },
      {
        name: "paes-bolos-e-doces",
        id: "84",
      },
      {
        name: "acompanhamentos",
        id: "85",
      },
    ],
  },
];
